import React from 'react';
import { useTranslation } from 'react-i18next';

// false 면 자동 숨김 비활성화
export const TOAST_AUTO_HIDE_ENABLED = false;
// 자동 숨김 시간(초)
export const TOAST_AUTO_HIDE_SECONDS = 5;

const NotificationTopRightToast = ({
  visible = false,
  closing = false,
  title,
  description = '',
  onClick,
  onClose,
}) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('headerTop.notificationToastDefault');
  if (!visible) return null;

  const handleClose = (e) => {
    e.stopPropagation();
    if (typeof onClose === 'function') onClose();
  };

  return (
    <div className={`notification-top-right-toast ${closing ? 'is-closing' : 'is-open'}`}>
      <style>{`
        .notification-top-right-toast {
          position: fixed;
          top: 20px;
          right: 20px;
          width: min(360px, calc(100vw - 40px));
          border-radius: 12px;
          border: 1px solid var(--theme-color-primary);
          background: #ffffff;
          box-shadow: 0 10px 28px rgba(2, 6, 23, 0.18);
          z-index: 11000;
          cursor: pointer;
          overflow: hidden;
          transform: translateY(-16px);
          opacity: 0;
        }
        .notification-top-right-toast.is-open {
          animation: notification-toast-slide-in 0.24s ease-out forwards;
        }
        .notification-top-right-toast.is-closing {
          animation: notification-toast-slide-out 0.24s ease-in forwards;
        }
        .notification-top-right-toast__inner {
          position: relative;
          padding: 14px 16px 12px;
        }
        .notification-top-right-toast__title {
          font-size: 14px;
          font-weight: 700;
          line-height: 1.35;
          color: #111827;
          margin: 0 22px 2px 0;
        }
        .notification-top-right-toast__description {
          font-size: 12px;
          color: #6b7280;
          line-height: 1.35;
          margin: 0;
        }
        .notification-top-right-toast__close {
          position: absolute;
          top: 8px;
          right: 8px;
          width: 22px;
          height: 22px;
          border: none;
          border-radius: 999px;
          background: transparent;
          color: #6b7280;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        .notification-top-right-toast__close:hover {
          background: #f3f4f6;
          color: #111827;
        }
        @keyframes notification-toast-slide-in {
          from { transform: translateY(-16px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes notification-toast-slide-out {
          from { transform: translateY(0); opacity: 1; }
          to { transform: translateY(-16px); opacity: 0; }
        }
      `}</style>
      <div
        className="notification-top-right-toast__inner"
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (typeof onClick === 'function') onClick();
          }
        }}
      >
        <button
          type="button"
          className="notification-top-right-toast__close"
          aria-label={t('components.common.closeToast')}
          onClick={handleClose}
        >
          ×
        </button>
        <p className="notification-top-right-toast__title">{resolvedTitle}</p>
        {description ? <p className="notification-top-right-toast__description">{description}</p> : null}
      </div>
    </div>
  );
};

export default NotificationTopRightToast;
